import ApiClient from '@/services/apiClient';

export default class MecaConfig {
  provider;
  product_serial;
  product_address;
  gateway_ip;
  gateway_name;
  gateway_address;
  remote_opening;
  card_size;
  white_list;

  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MecaConfig();
      obj.provider = ApiClient.convertToType(data['provider'], 'String');
      obj.product_serial = ApiClient.convertToType(data['product_serial'], 'String');
      obj.product_address = ApiClient.convertToType(data['product_address'], 'Integer');
      obj.gateway_ip = ApiClient.convertToType(data['gateway_ip'], 'String');
      obj.gateway_name = ApiClient.convertToType(data['gateway_name'], 'String');
      obj.gateway_address = ApiClient.convertToType(data['gateway_address'], 'Integer');
      obj.remote_opening = ApiClient.convertToType(data['remote_opening'], 'Boolean');
      obj.card_size = ApiClient.convertToType(data['card_size'], 'Integer');
      obj.white_list = ApiClient.convertToType(data['white_list'], ['Integer']);
    }
    return obj;
  }

  // Address of the handle or cylinder in hexadecimal, with its serial when known, as in the app
  get information() {
    const size = this.provider === 'Aperio' ? 6 : 8;
    const address = Number(this.product_address ?? 0).toString(16).padStart(size, '0').toUpperCase();
    return this.product_serial != null ? `${address} (${this.product_serial})` : address;
  }

  toJSON() {
    const json = {
      provider: this.provider,
      product_serial: this.product_serial,
      product_address: this.product_address,
      gateway_ip: this.gateway_ip,
      gateway_name: this.gateway_name,
      gateway_address: this.gateway_address,
      remote_opening: this.remote_opening,
      card_size: this.card_size,
      white_list: this.white_list,
    };
    return json;
  }
}
